import { render } from "./MagentoVersionSwitching.vue?vue&type=template&id=112746e3"
import script from "./MagentoVersionSwitching.vue?vue&type=script&lang=js"
export * from "./MagentoVersionSwitching.vue?vue&type=script&lang=js"

import "./MagentoVersionSwitching.vue?vue&type=style&index=0&id=112746e3&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__